import { Icon } from '@iconify/react/dist/iconify.js'
import BottomBar from '../bars/bottomBar/bottomBar'
import { GetInfo } from '../bars/bottomBar/request'
import './styles/desktop.css'
import './styles/mobile.css'

function Contact() {
    const info = GetInfo()

    return (
        <div className='contactPage'>
            <section className='contactHero'>
                <p className='contactHeroEyebrow'>CONTACTO</p>
                <h1>Hablemos de tu proyecto</h1>
                <p className='contactHeroText'>
                    Esta es una ventana dedicada para contactarnos con mas comodidad. Puedes enviarnos un mensaje
                    directo y ver toda la informacion de contacto en un solo lugar.
                </p>
            </section>

            <section className='contactLayout'>
                <article className='contactInfoPanel'>
                    <h2>Informacion de contacto</h2>
                    <div className='contactInfoRows'>
                        <p><strong>Telefono:</strong> {info.tel}</p>
                        <p><strong>Email:</strong> {info.email}</p>
                        <p><strong>Web:</strong> <a href={info.site}>{info.site}</a></p>
                        <p><strong>Direccion:</strong> {info.dir}</p>
                    </div>

                    <div className='contactSocials'>
                        <a href='/' aria-label='Facebook'><Icon className='socialIcon' icon='uiw:facebook' /></a>
                        <a href='/' aria-label='Twitter'><Icon className='socialIcon' icon='prime:twitter' /></a>
                    </div>

                    <a className='contactEmailAction' href={`mailto:${info.email}`}>
                        Escribir por email
                    </a>
                </article>

                <article className='contactFormPanel'>
                    <h2>Enviar mensaje</h2>

                    <form className='contactBigForm'>
                        <label htmlFor='contact-name'>Nombre</label>
                        <input id='contact-name' type='text' placeholder='Tu nombre' />

                        <label htmlFor='contact-email'>Email</label>
                        <input id='contact-email' type='email' placeholder='tu@email.com' />

                        <label htmlFor='contact-message'>Mensaje</label>
                        <textarea id='contact-message' placeholder='Cuentanos sobre tu proyecto' />

                        <button type='button'>Enviar</button>
                    </form>
                </article>
            </section>

            <BottomBar />
        </div>
    )
}

export default Contact
